export function isObject(item: unknown): boolean {
    return !!item && (typeof item === 'object' || typeof item === 'function');
}
